/** The owner's savings: cash taken home, and what is paid out of it. */
const savings = {
  en: {
    title: "Savings",
    subtitle:
      "The cash you take home or move out of the drawer, and what you pay from it. This is your own money — it is never counted as an expense or as revenue.",
    loadFailed: "Could not load your savings.",
    balance: "In your savings",
    balanceHint: "Everything taken home, less everything paid or taken out since.",
    add: "Add money",
    take: "Take money out",
    amount: "Amount ({currency})",
    note: "Note (optional)",
    save: "Save",
    saved: "Recorded.",
    saveFailed: "Could not record that.",
    insufficient: "There is not enough in your savings for that.",
    reasonTitle: "What is it for?",
    forPeriod: "From {from} to {to}",
    period: {
      taken_home: "Taken home from the till",
      added_by_hand: "Added by hand",
      returned_to_drawer: "Put back in the drawer",
      paid_expenses: "Paid for expenses",
      paid_suppliers: "Paid to suppliers",
      personal_use: "Taken for personal use",
      other_out: "Other withdrawals",
      owner_money_in: "Your own money put in the till",
    },
    personalNote:
      "Personal use and your own money are not expenses and not revenue: net revenue never changes because of them.",
    reasons: {
      closing: "Taken home at closing",
      from_drawer: "Moved from the drawer",
      deposit: "Added by hand",
      to_drawer: "Put back in the drawer",
      supplier: "Paid a supplier",
      expense: "Paid an expense",
      personal: "Personal use",
      other: "Other",
    },
    withdrawReasons: {
      personal: "Personal use",
      other: "Other (bank, correction…)",
    },
    history: "Movements",
    none: "Nothing in this period.",
  },
  fr: {
    title: "Épargne",
    subtitle:
      "L'argent que vous emportez ou sortez du tiroir, et ce que vous payez avec. C'est votre argent : il n'est jamais compté comme une dépense ni comme un revenu.",
    loadFailed: "Impossible de charger votre épargne.",
    balance: "Dans votre épargne",
    balanceHint: "Tout ce qui a été emporté, moins tout ce qui a été payé ou sorti depuis.",
    add: "Ajouter de l'argent",
    take: "Sortir de l'argent",
    amount: "Montant ({currency})",
    note: "Note (facultatif)",
    save: "Enregistrer",
    saved: "Enregistré.",
    saveFailed: "Impossible d'enregistrer.",
    insufficient: "Il n'y a pas assez dans votre épargne.",
    reasonTitle: "C'est pour quoi ?",
    forPeriod: "Du {from} au {to}",
    period: {
      taken_home: "Emporté depuis la caisse",
      added_by_hand: "Ajouté à la main",
      returned_to_drawer: "Remis dans le tiroir",
      paid_expenses: "Payé pour des dépenses",
      paid_suppliers: "Payé aux fournisseurs",
      personal_use: "Pris pour un usage personnel",
      other_out: "Autres retraits",
      owner_money_in: "Votre propre argent mis en caisse",
    },
    personalNote:
      "L'usage personnel et votre propre argent ne sont ni des dépenses ni des revenus : le résultat net ne change jamais à cause d'eux.",
    reasons: {
      closing: "Emporté à la fermeture",
      from_drawer: "Sorti du tiroir",
      deposit: "Ajouté à la main",
      to_drawer: "Remis dans le tiroir",
      supplier: "Payé un fournisseur",
      expense: "Payé une dépense",
      personal: "Usage personnel",
      other: "Autre",
    },
    withdrawReasons: {
      personal: "Usage personnel",
      other: "Autre (banque, correction…)",
    },
    history: "Mouvements",
    none: "Rien sur cette période.",
  },
  ar: {
    title: "المدخرات",
    subtitle:
      "النقود التي تأخذها إلى البيت أو تُخرجها من الدرج، وما تدفعه منها. هذا مالك الخاص: لا يُحتسب أبداً مصروفاً ولا إيراداً.",
    loadFailed: "تعذّر تحميل مدخراتك.",
    balance: "في مدخراتك",
    balanceHint: "كل ما أُخذ إلى البيت، مطروحاً منه كل ما دُفع أو أُخرج بعد ذلك.",
    add: "إضافة مال",
    take: "سحب مال",
    amount: "المبلغ ({currency})",
    note: "ملاحظة (اختيارية)",
    save: "حفظ",
    saved: "تم التسجيل.",
    saveFailed: "تعذّر التسجيل.",
    insufficient: "لا يوجد في مدخراتك ما يكفي لذلك.",
    reasonTitle: "لأي غرض؟",
    forPeriod: "من {from} إلى {to}",
    period: {
      taken_home: "المأخوذ إلى البيت من الصندوق",
      added_by_hand: "المضاف يدوياً",
      returned_to_drawer: "المُعاد إلى الدرج",
      paid_expenses: "المدفوع للمصاريف",
      paid_suppliers: "المدفوع للموردين",
      personal_use: "المأخوذ للاستعمال الشخصي",
      other_out: "سحوبات أخرى",
      owner_money_in: "مالك الخاص الموضوع في الصندوق",
    },
    personalNote:
      "الاستعمال الشخصي ومالك الخاص ليسا مصاريف ولا إيرادات: صافي الإيراد لا يتغير بسببهما أبداً.",
    reasons: {
      closing: "أُخذ إلى البيت عند الإغلاق",
      from_drawer: "نُقل من الدرج",
      deposit: "أُضيف يدوياً",
      to_drawer: "أُعيد إلى الدرج",
      supplier: "دُفع لمورّد",
      expense: "دُفع لمصروف",
      personal: "استعمال شخصي",
      other: "أخرى",
    },
    withdrawReasons: {
      personal: "استعمال شخصي",
      other: "أخرى (بنك، تصحيح…)",
    },
    history: "الحركات",
    none: "لا شيء في هذه الفترة.",
  },
};

export default savings;
